var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallers"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#de5d0a"}})],1):_c('div',[_c('VetSubsidiaries')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }